import React from 'react';

interface CustomEmojiProps {
  /** URL вашей картинки (PNG/SVG и т.п.), которую нужно подставить вместо стандартного сердечка */
  src: string;
  /** Какой эмоджи-символ нужно копировать при выделении. По умолчанию – ❤️ */
  symbol?: string;
}

/**
 * Inline-компонент, который:
 * 1) Рендерит в DOM невидимый (color: transparent) символ-эмоджи (например, "❤️").
 * 2) Абсолютно позиционирует поверх него <img> с вашим src, чтобы визуально было изображение.
 * 3) У <img> alt="" и aria-hidden="true" — чтобы при копировании браузер НЕ вставлял alt-текст.
 *
 * Таким образом, при выделении текста в буфер попадёт именно символ {symbol}, а не картинка.
 */
const CustomEmoji: React.FC<CustomEmojiProps> = ({ src, symbol = '❤️' }) => {
  return (
    <span
      style={{
        display: 'inline-block',
        width: '1em',
        height: '1em',
        position: 'relative',
        color: 'transparent', // скрываем сам текст-эмоджи, но он остаётся в DOM
        verticalAlign: 'text-bottom', // выравнивание по базовой линии текста
        lineHeight: 1, // чтобы span ровно занимал высоту 1em
        overflow: 'hidden', // обрезаем всё, что выходит за границы
        userSelect: 'text', // оставляем текст селектируемым
      }}
    >
      <img
        src={src}
        alt="" // убрали alt-текст, чтобы не копировался
        aria-hidden="true" // говорим screen reader’ам и браузеру игнорировать картинку при копировании
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          pointerEvents: 'none', // чтобы при клике/драг-селекте выбран был символ, а не картинка
          imageRendering: 'pixelated',
        }}
      />
      {symbol}
    </span>
  );
};

export default CustomEmoji;
